module.exports = __webpack_public_path__ + "static/media/6.f88a69b1.jpg";